<div class="template-editor-page">
  <!-- Painel Esquerdo: Editor -->
  <div class="editor-panel">
    <!-- Cabecalho -->
    <div class="editor-header">
      <div class="editor-header-left">
        <button
          class="btn-voltar"
          (click)="descarte()"
          [disabled]="salvando">
          <i class="fas fa-arrow-left"></i> Voltar
        </button>

        <div class="editor-title">
          <!-- Back button removed to match image -->
          <div class="title-content">
            <h2>{{ template.nomeTemplate || 'Novo Template' }}</h2>
            <span class="editing-badge">EDITANDO MODELO</span>
          </div>
          <div class="meta-status-row" *ngIf="template.status">
            <span class="meta-status-badge" [ngClass]="obtenhaCorStatus(template.status)">
              <i class="fas" [ngClass]="obtenhaIconeStatus(template.status)"></i>
              {{ getTranslatedStatus(template.status) }}
            </span>
            <span class="last-update-info" *ngIf="template.dataUltimaAlteracao">
                  <i class="fas fa-history"></i>
                  Última alteração: {{ template.dataUltimaAlteracao | date:'dd/MM/yyyy HH:mm' }}
              </span>
          </div>
        </div>
      </div>

      <div class="editor-actions">
        <button
          class="btn-salvar"
          (click)="salve()"
          [disabled]="salvando">
          {{ salvando ? 'Salvando...' : 'Salvar Alterações' }}
        </button>
      </div>
    </div>

    <!-- Banner de Erro -->
    <div class="error-banner" *ngIf="showErrorModal">
      <div class="error-banner-content">
        <i class="fas fa-exclamation-circle"></i>
        <span>{{ errorModalMessage }}</span>
      </div>
      <button class="error-banner-close" (click)="fecheModalErro()">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- Mobile Tab Nav -->
    <div class="mobile-tab-nav">
      <button 
        class="tab-btn" 
        [class.active]="mobileTab === 'editor'"
        (click)="switchMobileTab('editor')">
        <i class="fas fa-edit"></i> Editar
      </button>
      <button 
        class="tab-btn" 
        [class.active]="mobileTab === 'preview'"
        (click)="switchMobileTab('preview')">
        <i class="fas fa-mobile-alt"></i> Visualizar
      </button>
    </div>

    <!-- Secao: Cartão Unificado de Mensagem -->
    <div class="editor-section-group" [class.mobile-hidden]="mobileTab === 'preview'">
      <label class="group-label">ESTRUTURA DA MENSAGEM</label>

            <div class="unified-message-card">

                              <!-- 1. Topo: Cabeçalho -->

                              <div class="card-section card-header-section"

                                   [class.active-section]="activeField === 'header'">

                                <!-- Mobile Label -->
                                <div class="mobile-section-label">
                                  <i class="fas fa-heading"></i> CABEÇALHO
                                </div>

                                <!-- Blueprint Label (Desktop Only) -->

                                <div class="blueprint-label" (click)="headerInput.focus()">

                                    <div class="label-box">

                                        <i class="fas fa-heading"></i>

                                        <span>Cabeçalho</span>

                                    </div>

                                    <div class="connector-line"></div>

                                </div>



                                <input

                                  #headerInput

                                  id="headerInput"

                                  type="text"

                                  (focusin)="activeField = 'header'"

                                  [(ngModel)]="template.headerText"

                                  (ngModelChange)="updateSimulationList()"

                                  [maxLength]="MAX_HEADER_LENGTH"

                                  placeholder="Texto de destaque no topo"

                                  class="seamless-input header-input">

                              </div>



                              <!-- 2. Meio: Corpo (Principal) -->

                              <div class="card-section card-body-section"

                                   [class.active-section]="activeField === 'body'">

                                <!-- Mobile Label -->
                                <div class="mobile-section-label">
                                  <i class="fas fa-align-left"></i> MENSAGEM
                                </div>

                                <!-- Blueprint Label -->

                                <div class="blueprint-label" (click)="bodyInputRef.focus()">

                                    <div class="label-box">

                                        <i class="fas fa-align-left"></i>

                                        <span>Mensagem</span>

                                    </div>

                                    <div class="connector-line"></div>

                                </div>



                                <div class="body-tools-overlay">

                                  <div class="formatting-group">

                                     <button class="tool-btn" (click)="apliqueBold()" title="Negrito"><strong>B</strong></button>

                                     <button class="tool-btn" (click)="apliqueItalico()" title="Itálico"><em>I</em></button>

                                     <button class="tool-btn" (click)="apliqueStrikethrough()" title="Tachado"><s>S</s></button>

                                  </div>

                                  <div class="variable-trigger-wrapper">

                                      <button class="tool-btn variable-btn" (click)="toggleVariableDropdown()">

                                        <i class="fas fa-magic"></i> Variáveis

                                      </button>

                                      <!-- Dropdown -->

                                      <div class="dropdown-content variables-dropdown" *ngIf="showVariableDropdown">

                                        <div *ngFor="let group of groupedVariables" class="variable-group">

                                          <div class="group-header">{{ group.label }}</div>

                                          <button

                                            *ngFor="let variable of group.variables"

                                            (click)="insiraVariavel(variable)"

                                            class="variable-option">

                                            <i class="fas" [ngClass]="variable.icon"></i>

                                            {{ variable.label }}

                                          </button>

                                        </div>

                                      </div>

                                  </div>

                                </div>



                                <textarea

                                  #bodyInputRef

                                  id="bodyTextarea"

                                  name="bodyText"

                                  (focusin)="activeField = 'body'"

                                  [(ngModel)]="template.bodyText"

                                  (ngModelChange)="updateSimulationList()"

                                  [maxLength]="MAX_BODY_LENGTH"

                                  rows="8"

                                  placeholder="Digite o conteúdo da sua mensagem aqui..."

                                  class="seamless-textarea"

                                  [class.is-invalid]="tentouSalvar && !template.bodyText?.trim()"

                                  required

                                  #bodyText="ngModel"></textarea>



                                 <div class="invalid-feedback-floating" *ngIf="tentouSalvar && !template.bodyText?.trim()">

                                   <i class="fas fa-exclamation-circle"></i> Conteúdo obrigatório

                                 </div>

                              </div>



                              <!-- 3. Base: Rodapé -->

                              <div class="card-section card-footer-section"

                                   [class.active-section]="activeField === 'footer'">

                                <!-- Mobile Label -->
                                <div class="mobile-section-label">
                                  <i class="fas fa-shoe-prints"></i> RODAPÉ
                                </div>

                                <!-- Blueprint Label -->

                                <div class="blueprint-label" (click)="footerInput.focus()">

                                    <div class="label-box">

                                        <i class="fas fa-shoe-prints"></i>

                                        <span>Rodapé</span>

                                    </div>

                                    <div class="connector-line"></div>

                                </div>



                                <input

                                  #footerInput

                                  type="text"

                                  (focusin)="activeField = 'footer'"

                                  [(ngModel)]="template.footerText"

                                  [maxLength]="MAX_FOOTER_LENGTH"

                                  placeholder="Texto pequeno e cinza no final"

                                  class="seamless-input footer-input">

                              </div>            </div>    </div>

    <!-- Secao: Botoes (Separado) -->
    <div class="editor-section" [class.mobile-hidden]="mobileTab === 'preview'">
      <div class="section-header">
        <label class="section-label">BOTÕES</label>
        <span class="buttons-type-badge">Opcional</span>
      </div>

      <div class="buttons-list">
         <div *ngFor="let button of template.buttons; let i = index" class="button-config">
             <button class="btn-remove-button" (click)="removaButton(i)"><i class="fas fa-trash-alt"></i></button>

             <!-- Fields for Quick Reply -->
             <div class="button-fields" *ngIf="button.actionType === 'QUICK_REPLY'">
                <div class="button-text-field">
                  <label class="field-label" style="display: flex; align-items: center; gap: 0.5rem; color: #64748b;">
                    <i class="fas fa-reply"></i> Resposta Rápida
                  </label>
                  <input
                    type="text"
                    [name]="'buttonText' + i"
                    [(ngModel)]="button.text"
                    [maxLength]="MAX_BUTTON_TEXT_LENGTH"
                    placeholder="Ex: Sim, quero"
                    class="button-input"
                    style="margin-top: 0.5rem;"
                    [class.is-invalid]="tentouSalvar && !button.text?.trim()"
                    required>
                  <div class="invalid-feedback" *ngIf="tentouSalvar && !button.text?.trim()">
                    <p><i class="fas fa-exclamation-circle"></i> O texto do botão é obrigatório</p>
                  </div>
                </div>
             </div>

             <!-- Fields for CTA -->
             <div class="button-fields" *ngIf="button.actionType === 'VISITAR_SITE'">
                <div class="button-text-field">
                  <label class="field-label" style="display: flex; align-items: center; gap: 0.5rem; color: #64748b;">
                    <i class="fas fa-external-link-alt"></i> Visitar Site
                  </label>
                  <input
                    type="text"
                    [name]="'buttonTextCta' + i"
                    [(ngModel)]="button.text"
                    [maxLength]="MAX_BUTTON_TEXT_LENGTH"
                    placeholder="Ex: Ver Site"
                    class="button-input"
                    style="margin-top: 0.5rem;"
                    [class.is-invalid]="tentouSalvar && !button.text?.trim()"
                    required>
                  <div class="invalid-feedback" *ngIf="tentouSalvar && !button.text?.trim()">
                    <p><i class="fas fa-exclamation-circle"></i> O texto do botão é obrigatório</p>
                  </div>
                </div>

                <div class="button-value-field">
                  <label class="field-label">
                    <i class="fas fa-link"></i> LINK DO SISTEMA
                  </label>
                  <select
                    class="button-select"
                    [name]="'buttonLinkKey' + i"
                    [(ngModel)]="button.linkKey"
                    [class.is-invalid]="tentouSalvar && !button.linkKey"
                    required>
                    <option value="">Selecione um link...</option>
                    <option *ngFor="let link of buttonLinkOptions" [value]="link.key">
                      {{ link.label }} - {{ link.description }}
                    </option>
                  </select>
                  <div class="invalid-feedback" *ngIf="tentouSalvar && !button.linkKey">
                    <p><i class="fas fa-exclamation-circle"></i> Selecione um link do sistema</p>
                  </div>
                </div>
             </div>
         </div>
      </div>

      <div *ngIf="template.buttons.length === 0" class="no-buttons mb-3">
          <i class="fas fa-mouse-pointer"></i>
          <span>Nenhum botão adicionado</span>
      </div>

      <!-- Add Button Dropdown -->
      <div class="add-button-container" style="position: relative;"
           *ngIf="canAddMoreButtons">

        <button class="btn-add-button" (click)="toggleAddButtonDropdown()">
          <i class="fas fa-plus"></i>
          Adicionar botão
          <i class="fas fa-chevron-down" style="margin-left: 0.5rem; font-size: 0.8rem;"></i>
        </button>

        <div class="dropdown-content" *ngIf="showAddButtonDropdown" style="width: 100%; top: 100%; margin-top: 0.5rem;">
            <button class="variable-option"
              (click)="adicioneButton('QUICK_REPLY')">
              <i class="fas fa-reply"></i>
              Resposta Rápida
            </button>
            <button class="variable-option"
              [disabled]="!canAddMoreLinks"
              (click)="adicioneButton('VISITAR_SITE')"
              [style.opacity]="!canAddMoreLinks ? '0.5' : '1'">
              <i class="fas fa-external-link-alt"></i>
              Visitar site
              <span style="margin-left: auto; font-size: 0.65rem; color: #94a3b8;">2 botões máx</span>
            </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Painel Direito: Preview -->
  <div class="preview-panel" [class.mobile-visible]="mobileTab === 'preview'">
    <!-- Mockup do Celular WhatsApp -->
    <div class="phone-mockup">
      <div class="phone-frame">
        <div class="phone-status-bar">
          <span class="time">12:30</span>
           <div class="status-icons">
            <i class="fas fa-wifi" style="font-size: 10px; margin-right: 4px;"></i>
            <i class="fas fa-battery-full" style="font-size: 10px;"></i>
           </div>
        </div>
        <div class="phone-header">
          <i class="fas fa-arrow-left"></i>
          <div class="contact-avatar">
            <i class="fas fa-motorcycle"></i>
          </div>
          <div class="contact-info">
            <span class="contact-name">{{ template.nomeTemplate || 'Template' }}</span>
            <span class="contact-status">Online</span>
          </div>
          <div class="header-actions">
            <i class="fas fa-video"></i>
            <i class="fas fa-phone"></i>
            <i class="fas fa-ellipsis-v"></i>
          </div>
        </div>

        <div class="phone-chat">
          <div class="date-divider">
             <span>Hoje</span>
          </div>

          <div class="message-bubble">
            <div class="message-header" *ngIf="template.headerText">
              <strong>{{ obtenhaPreviewHeader() }}</strong>
            </div>
            <div class="message-body" [innerHTML]="obtenhaPreviewBody()"></div>
            <div class="message-footer" *ngIf="template.footerText">
              <em>{{ template.footerText }}</em>
            </div>
            <div class="message-meta">
               <span class="message-time">12:31</span>
            </div>
          </div>

          <div class="message-buttons" *ngIf="template.buttons.length > 0">
            <button
              *ngFor="let button of template.buttons"
              class="preview-button">
              <i class="fas" [ngClass]="{
                'fa-reply': button.actionType === 'QUICK_REPLY',
                'fa-external-link-alt': button.actionType === 'VISITAR_SITE'
              }"></i>
              {{ button.text || 'Botão' }}
            </button>
          </div>
        </div>

        <div class="phone-input-bar">
          <i class="fas fa-plus"></i>
          <div class="input-fake">Mensagem</div>
          <i class="fas fa-microphone"></i>
        </div>
      </div>
    </div>

    <!-- Painel de Dados da Simulacao -->
    <div class="simulation-panel">
      <div class="simulation-header">
        <div class="simulation-title-row">
          <i class="fas fa-sliders-h"></i>
          <span class="simulation-title">DADOS DA SIMULAÇÃO</span>
        </div>
        <span class="variable-count-badge">
          {{ obtenhaContagemVariaveis() }} variáveis
        </span>
      </div>
      <div class="simulation-list">
        <div *ngIf="simulationVariables.length === 0" class="simulation-empty-state">
           <div class="empty-icon-wrapper">
             <i class="fas fa-magic"></i>
           </div>
           <span>Nenhuma variável em uso</span>
           <small>Adicione variáveis no texto para simular valores.</small>
        </div>

        <div
          *ngFor="let variable of simulationVariables; let i = index"
          class="simulation-item">
          <div class="simulation-item-header">
            <div class="label-group">
                <span class="meta-param-badge" title="Este campo será enviado como {{ '{{' + (i+1) + '}}' }} para a Meta">#{{i + 1}}</span>
                <i class="fas" [ngClass]="variable.icon"></i>
                <span class="simulation-label">{{ variable.label }}</span>
            </div>
            <span class="simulation-placeholder">{{ variable.placeholder }}</span>
          </div>
          <div class="simulation-input-wrapper">
            <span class="input-icon">T</span>
            <input
              type="text"
              [value]="variable.simulationValue"
              (input)="atualizeSimulacao(i, $any($event.target).value)"
              class="simulation-input">
          </div>
        </div>
      </div>
      <div class="simulation-note">
        <i class="fas fa-info-circle"></i>
        Estes dados são apenas para o teu teste local.
      </div>
    </div>
  </div>

  <!-- Mobile Sticky Footer Actions -->
  <div class="mobile-actions-footer">
    <button
      class="btn-voltar mobile"
      (click)="descarte()"
      [disabled]="salvando">
      <i class="fas fa-arrow-left"></i> Voltar
    </button>

    <button
      class="btn-salvar mobile"
      (click)="salve()"
      [disabled]="salvando">
      {{ salvando ? 'Salvando...' : 'Salvar' }}
    </button>
  </div>

</div>
